export const DESIGN_COPY = {
  dialogClose: '關閉',
  textSize: '文字大小',
  textSizes: { xsmall: '特小', small: '小', reduced: '略小', standard: '標準', large: '大', xlarge: '特大' },
  previousPage: '上一頁',
  nextPage: '下一頁',
} as const
